import { makeStyles } from "tss-react/mui"
import { MenuItem, TextField } from "@mui/material"
import { CreateMobileAVResourceForm, RoomDetailsColor } from "../../../resourcesTypes"
import { StandardForm } from "../../../../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../../../../shared/components/forms/StandardMainPanel"
import { LocalizedStrict } from "../../../../../../../localization/components/AppLocalized"
import {
    FormikAutoComplete,
    FormikDropdown,
    FormikSwitch,
    FormikTextField,
} from "../../../../../../../../shared/components/forms/Formik"
import { StandardSidePanel } from "../../../../../../../../shared/components/forms/StandardSidePanel"
import { NotificationsTable } from "../../room/general/NotificationsTable"
import { useFormikContext } from "formik"

const useStyles = makeStyles()(() => ({
    roomNumberInput: {
        width: "50%",
    },
    percentageInput: {
        width: "7.5rem",
    },
}))

const cleanupBufferOptions = Array.from({ length: 12 }, (_, index) => index * 5)

export function FormMobileAVGeneralContent() {
    const { classes } = useStyles()
    const { values } = useFormikContext<CreateMobileAVResourceForm>()

    return (
        <StandardForm>
            <StandardMainPanel>
                <LocalizedStrict
                    id="resources-create-mobile-av-tab-general-serial-number-label"
                    attrs={{ label: true }}
                >
                    <FormikTextField name="avDetails.serialNumber" label="Serial number" />
                </LocalizedStrict>
                <LocalizedStrict id="resources-create-mobile-av-tab-general-name-label" attrs={{ label: true }}>
                    <FormikTextField name="name" label="Name" />
                </LocalizedStrict>
                <LocalizedStrict id="resources-create-mobile-av-tab-general-description-label" attrs={{ label: true }}>
                    <FormikTextField rows={4} multiline name="description" label="Description" />
                </LocalizedStrict>
                <LocalizedStrict
                    id="resources-create-mobile-av-tab-general-storage-location-label"
                    attrs={{ label: true }}
                >
                    <FormikTextField name="avDetails.storageLocation" label="Storage location" />
                </LocalizedStrict>
                <LocalizedStrict id="resources-create-mobile-av-tab-general-color-code-label" attrs={{ label: true }}>
                    <FormikDropdown name="color" label="Color code">
                        <MenuItem value={RoomDetailsColor.RED}>
                            <LocalizedStrict id="resources-create-room-tab-general-color-red">
                                <span>Red</span>
                            </LocalizedStrict>
                        </MenuItem>
                        <MenuItem value={RoomDetailsColor.GREEN}>
                            <LocalizedStrict id="resources-create-room-tab-general-color-green">
                                <span>Green</span>
                            </LocalizedStrict>
                        </MenuItem>
                        <MenuItem value={RoomDetailsColor.BLUE}>
                            <LocalizedStrict id="resources-create-room-tab-general-color-blue">
                                <span>Blue</span>
                            </LocalizedStrict>
                        </MenuItem>
                        <MenuItem value={RoomDetailsColor.BLACK}>
                            <LocalizedStrict id="resources-create-room-tab-general-color-black">
                                <span>Black</span>
                            </LocalizedStrict>
                        </MenuItem>
                        <MenuItem value={RoomDetailsColor.LIGHT_BLUE}>
                            <LocalizedStrict id="resources-create-room-tab-general-color-light-blue">
                                <span>Light Blue</span>
                            </LocalizedStrict>
                        </MenuItem>
                    </FormikDropdown>
                </LocalizedStrict>

                <LocalizedStrict id="resources-create-mobile-av-tab-general-floor-label" attrs={{ label: true }}>
                    <FormikTextField name="avDetails.floor" label="Storage location" type="number" />
                </LocalizedStrict>
                <LocalizedStrict
                    id="resources-create-mobile-av-tab-general-cleanup-buffer-label"
                    attrs={{ label: true }}
                >
                    <FormikDropdown name="buffer" label="Cleanup buffer">
                        {cleanupBufferOptions.map((value) => (
                            <MenuItem key={value} value={value}>
                                {value}
                            </MenuItem>
                        ))}
                    </FormikDropdown>
                </LocalizedStrict>
                <LocalizedStrict id="resources-create-room-tab-general-tags-label" attrs={{ label: true }}>
                    <FormikAutoComplete
                        name="tags"
                        label="Tags"
                        freeSolo
                        multiple
                        options={values.tags ?? []}
                        fullWidth
                        renderInput={() => <TextField />}
                    />
                </LocalizedStrict>
            </StandardMainPanel>
            <LocalizedStrict id="resources-create-mobile-av-tab-general-side-settings" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Settings">
                    <LocalizedStrict id="resources-create-mobile-av-tab-general-active-label">
                        <FormikSwitch<CreateMobileAVResourceForm> name="isActive">Active:</FormikSwitch>
                    </LocalizedStrict>
                </StandardSidePanel>
            </LocalizedStrict>
            <StandardMainPanel title="Reminders">
                <NotificationsTable />
            </StandardMainPanel>
        </StandardForm>
    )
}
